var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-practice__form font-size-16 color-gray-10" },
    [
      _vm.value.type === 5
        ? [
            _c(
              "div",
              [
                _c("div", {
                  staticClass: "font-size-14 lh24",
                  attrs: { "data-rich-text": "1" },
                  domProps: {
                    innerHTML: _vm._s(_vm.cleanStyle(_vm.value.content)),
                  },
                }),
                _vm.value.fileId && _vm.value.questionType > 1
                  ? _c("media-player", {
                      key: _vm.value.id,
                      attrs: {
                        type: _vm.value.questionType,
                        options: _vm.playerOptions,
                        tranStatus: _vm.value.tranStatus,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : [
            _c("div", { staticClass: "yxtbiz-practice__form-sub" }, [
              _vm._v("\n      " + _vm._s(_vm.index + 1) + ".\n    "),
            ]),
            _c(
              "div",
              { staticClass: "yxtbiz-practice__form-content pl6" },
              [
                _c("div", {
                  attrs: { "data-rich-text": "1" },
                  domProps: {
                    innerHTML: _vm._s(_vm.cleanStyle(_vm.value.content)),
                  },
                }),
                _vm.value.fileId && _vm.value.questionType > 1
                  ? _c("media-player", {
                      key: _vm.value.id,
                      attrs: {
                        type: _vm.value.questionType,
                        options: _vm.playerOptions,
                        tranStatus: _vm.value.tranStatus,
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "mt16" },
                  [
                    _vm.value.type === 0
                      ? [
                          _c(
                            "yxtf-radio-group",
                            {
                              staticClass:
                                "mfl12 color-primary-6 yxtbiz-practice__radio-group active mv-f8",
                              attrs: {
                                direction: "row",
                                disabled: !!_vm.value.isAnswered
                                  ? "lock"
                                  : false,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.submitSingle()
                                },
                              },
                              model: {
                                value: _vm.value.answer,
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, "answer", $$v)
                                },
                                expression: "value.answer",
                              },
                            },
                            _vm._l(_vm.value.choiceItems, function (i, j) {
                              return _c(
                                "yxtf-radio",
                                {
                                  key: i.id,
                                  staticClass: "yxtbiz-practice__radio active",
                                  class: {
                                    "hover-primary-6-i": !_vm.value.isAnswered,
                                  },
                                  attrs: { label: i.id },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.convertASCIIForNum(j)) + ". "
                                    ),
                                  ]),
                                  _c("span", {
                                    attrs: { "data-rich-text": "1" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.cleanStyle(i.itemContent, true)
                                      ),
                                    },
                                  }),
                                  i.itemPlay && i.itemPlay.fileId
                                    ? _c("media-player", {
                                        key: i.itemPlay.fileId,
                                        attrs: {
                                          type: i.itemPlay.type,
                                          options: _vm.playerMediaOptions(
                                            i.itemPlay
                                          ),
                                          tranStatus: i.itemPlay.tranStatus,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ]
                      : _vm.value.type === 1
                      ? [
                          _c(
                            "yxtf-checkbox-group",
                            {
                              staticClass:
                                "mfl12 mv-f8 color-primary-6 yxtbiz-practice__checkbox-group active",
                              attrs: {
                                disabled: !!_vm.value.isAnswered
                                  ? "lock"
                                  : false,
                                direction: "row",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.submitSingle()
                                },
                              },
                              model: {
                                value: _vm.value.answers,
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, "answers", $$v)
                                },
                                expression: "value.answers",
                              },
                            },
                            _vm._l(_vm.value.choiceItems, function (i, j) {
                              return _c(
                                "yxtf-checkbox",
                                {
                                  key: i.id,
                                  staticClass:
                                    "yxtbiz-practice__checkbox active",
                                  class: {
                                    "hover-primary-6-i": !_vm.value.isAnswered,
                                  },
                                  attrs: { label: i.id },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.convertASCIIForNum(j)) + ". "
                                    ),
                                  ]),
                                  _c("span", {
                                    attrs: { "data-rich-text": "1" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.cleanStyle(i.itemContent, true)
                                      ),
                                    },
                                  }),
                                  i.itemPlay && i.itemPlay.fileId
                                    ? _c("media-player", {
                                        key: i.itemPlay.fileId,
                                        attrs: {
                                          type: i.itemPlay.type,
                                          options: _vm.playerMediaOptions(
                                            i.itemPlay
                                          ),
                                          tranStatus: i.itemPlay.tranStatus,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ]
                      : _vm.value.type === 2
                      ? [
                          _c(
                            "yxtf-radio-group",
                            {
                              staticClass:
                                "mfl12 mv-f8 color-primary-6 yxtbiz-practice__radio-group active",
                              attrs: {
                                disabled: !!_vm.value.isAnswered
                                  ? "lock"
                                  : false,
                                direction: "row",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.submitSingle()
                                },
                              },
                              model: {
                                value: _vm.value.submitContent,
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, "submitContent", $$v)
                                },
                                expression: "value.submitContent",
                              },
                            },
                            [
                              _c(
                                "yxtf-radio",
                                {
                                  key: _vm.value.id + "1",
                                  staticClass: "yxtbiz-practice__radio active",
                                  class: {
                                    "hover-primary-6-i": !_vm.value.isAnswered,
                                  },
                                  attrs: { label: "1" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.value.judgeCorrectOptionContent ||
                                        _vm.$t("pc_biz_ote_lbl_wright")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "yxtf-radio",
                                {
                                  key: _vm.value.id + "0",
                                  staticClass: "yxtbiz-practice__radio active",
                                  class: {
                                    "hover-primary-6-i": !_vm.value.isAnswered,
                                  },
                                  attrs: { label: "0" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.value.judgeWrongOptionContent ||
                                        _vm.$t("pc_biz_ote_lbl_wrong")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm.value.type === 3
                      ? _vm._l(_vm.value.fillInItems, function (i, j) {
                          return _c(
                            "div",
                            {
                              key: i.id,
                              staticClass:
                                "lh40 font-size-14 yxtbiz-practice__form",
                              class: { mt20: j > 0, mt16: j === 0 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "yxtbiz-practice__form-sub" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(j + 1) +
                                      ".\n            "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "yxtbiz-practice__form-content pl10",
                                },
                                [
                                  _c("yxtf-input", {
                                    staticClass: "yxtbiz-practice__form-input",
                                    attrs: {
                                      disabled: !!_vm.value.isAnswered,
                                      maxlength: "500",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.submitSingle()
                                      },
                                    },
                                    model: {
                                      value: i.submitAnswer,
                                      callback: function ($$v) {
                                        _vm.$set(i, "submitAnswer", $$v)
                                      },
                                      expression: "i.submitAnswer",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        })
                      : _vm.value.type === 4
                      ? [
                          _c("yxtf-input", {
                            staticClass: "yxtbiz-practice__form-textarea",
                            attrs: {
                              disabled: !!_vm.value.isAnswered,
                              type: "textarea",
                              autosize: { minRows: 5, maxRows: 8 },
                              maxlength: "2000",
                              "show-word-limit": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.submitSingle()
                              },
                            },
                            model: {
                              value: _vm.value.submitContent,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "submitContent", $$v)
                              },
                              expression: "value.submitContent",
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }